module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "update-username-dialog",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      "title": "修改总部管理员用户名"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [(_vm.updating) ? _c('el-form', {
    ref: "form",
    staticClass: "update-name-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rule,
      "label-width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleSave($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "当前总部管理员用户名"
    }
  }, [_c('span', [_vm._v(_vm._s(this.userInfo.username))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前登录密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "maxlength": 20
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新的总部管理员用户名",
      "prop": "newUserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.newUserName),
      callback: function($$v) {
        _vm.$set(_vm.form, "newUserName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.newUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新的总部管理员用户名",
      "prop": "confirmUserName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.confirmUserName),
      callback: function($$v) {
        _vm.$set(_vm.form, "confirmUserName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.confirmUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sm-input",
    attrs: {
      "label": "验证码",
      "prop": "captcha"
    }
  }, [_c('el-input', {
    ref: "captcha",
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "prefix-icon": "iconfont icon-yanzhengma",
      "maxlength": 4
    },
    model: {
      value: (_vm.form.captcha),
      callback: function($$v) {
        _vm.$set(_vm.form, "captcha", $$v)
      },
      expression: "form.captcha"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-captcha",
    attrs: {
      "src": ("/metis-login-web/captcha?captchaKey=" + (_vm.form.captchaKey))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "refresh-btn",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("刷新")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-btns"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.disabled,
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])], 1)], 1) : _c('div', {
    staticClass: "update-result"
  }, [_c('p', [_vm._v("恭喜您，修改成功！")]), _vm._v(" "), _c('p', [_vm._v("您的集团号：" + _vm._s(this.userInfo.agencyId) + " ")]), _vm._v(" "), _c('p', [_vm._v("新的总部管理员用户名： "), _c('span', {
    staticClass: "new-user-name"
  }, [_vm._v(_vm._s(this.form.newUserName))])]), _vm._v(" "), _c('p', [_vm._v("请牢记以上信息")]), _vm._v(" "), _c('p', [_vm._v("已向该账号的绑定手机 " + _vm._s(_vm._f("encrypt")(_vm.userInfo.mobile, 'phone')) + " 发送备忘短信，如您的手机号已更换，可在重新登录后通过【绑定手机号】更改")]), _vm._v(" "), _c('el-button', {
    staticClass: "retry-login",
    attrs: {
      "type": "primary",
      "disabled": _vm.reLoginDisabled
    },
    on: {
      "click": _vm.relogin
    }
  }, [_vm._v(_vm._s(_vm.reloginBtn))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab71626c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/UpdateName/UpdateName.vue
// module id = 762
// module chunks = 8